// scrub password fields from values before logging
export default function scrubPassword(values) {
    return { ...values, password: "********", "password-confirm": "********" }
}
